import { AlternateSectionBlock as AlternateSectionProps } from "@/payload-types";
import React from "react";
import { AlternateItem } from "../components/AlternateItem";

export const AlternateSectionBlock: React.FC<AlternateSectionProps> = ({
  anchor,
  items,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <section
      id={
        (anchor?.value &&
          typeof anchor.value === "object" &&
          anchor?.value.anchor) ||
        ""
      }
      className="flex flex-col w-full mb-10"
    >
      {items.map((item, index) => (
        <AlternateItem
          key={index}
          index={index} // Index qui déclenche l'alternance automatique
          title={item.title}
          text={item.content}
          media={item.media}
          links={item.links}
        />
      ))}
    </section>
  );
};
